/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstitle1Inputs */

const en_signupstitle1 = /** @type {(inputs: Signupstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New accounts`)
};

const de_signupstitle1 = /** @type {(inputs: Signupstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Konten`)
};

/**
* | output |
* | --- |
* | "New accounts" |
*
* @param {Signupstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstitle1 = /** @type {((inputs?: Signupstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstitle1(inputs)
	return de_signupstitle1(inputs)
});
export { signupstitle1 as "signupsTitle" }